import WordingMixin from '@/mixins/Wording'
import ScrollMixin from '@/mixins/Scroll'
import EventHubMixin from '@/mixins/EventHub'

import AppAnimatedText from '@/components/app-animated-text/'
import AppPushButton from '@/components/app-push-button/'
import AppButtonCircle from '@/components/app-button-circle/'

export default
{
    name: 'app-slider',

    mixins:
    [
        WordingMixin,
        ScrollMixin,
        EventHubMixin
    ],

    components:
    {
        AppAnimatedText,
        AppPushButton,
        AppButtonCircle
    },

    data()
    {
        return {
            active: false,
            visible: false,
            transitionning: false,
            blinking: false,
            index: 0,
            dataIndex: 0,
            lockLimit: 1,
            maxLimit: 4,
            amplitude: 70,
            isTitleVisible: false,
            isButtonVisible: false,
            isButtonActive: false,
            isDescriptionVisible: false,
            leftVisible: false,
            leftGrayCircleStart: 0,
            leftGrayCircleLength: 0,
            leftWhiteCircleStart: 0,
            leftWhiteCircleLength: 0,
            rightVisible: false,
            rightGrayCircleStart: 0,
            rightGrayCircleLength: 0,
            rightWhiteCircleStart: 0.5,
            rightWhiteCircleLength: 0
        }
    },

    watch:
    {
        $route()
        {
            this.active = this.$route.name === 'slider'

            if(this.active)
            {
                // Came from menu (no animation)
                if(this.$root.$previousRoute && this.$root.$previousRoute.name === 'menu')
                {
                    this.showTitles(2000)

                    this.visible = true
                }
            }

            else
            {
                this.hideTitles()
                this.visible = false
            }

            if(typeof this.$route.meta.sliderIndex !== 'undefined')
            {
                this.index = this.$route.meta.sliderIndex
            }
        },

        visible()
        {
            this.leftVisible = this.index > 0 && this.visible
            this.rightVisible = this.index < this.maxLimit - 1 && this.visible
        },

        leftVisible()
        {
            if(this.leftVisible)
            {
                this.leftGrayCircleStart = - 0.25
                this.leftGrayCircleLength = 1
            }
            else
            {
                this.leftGrayCircleStart = - 1.25
                this.leftGrayCircleLength = 0
            }
        },

        rightVisible()
        {
            if(this.rightVisible)
            {
                this.rightGrayCircleStart = - 0.25
                this.rightGrayCircleLength = 1
            }
            else
            {
                this.rightGrayCircleStart = - 1.25
                this.rightGrayCircleLength = 0
            }
        },

        index(_value, _oldValue)
        {
            // Play sounds
            this.$eventHub.$emit('sound.play', 'click')
            this.$eventHub.$emit('sound.play', 'transition')

            // Emit index change to experience
            this.$eventHub.$emit('experience.changeIndex', _value, _oldValue)

            // Update simings
            this.leftVisible = this.index > 0 && this.visible
            this.rightVisible = this.index < this.maxLimit - 1 && this.visible

            // Background transition
            this.transitionning = true

            if(this.transitionningTimeout)
            {
                window.clearTimeout(this.transitionningTimeout)
                this.transitionningTimeout = null
            }

            this.transitionningTimeout = window.setTimeout(() =>
            {
                this.transitionning = false
                this.transitionningTimeout = null
            }, 1500)

            // Index blinker
            this.isBlinking = true

            if(this.blinkingTimeout)
            {
                window.clearTimeout(this.blinkingTimeout)
                window.clearInterval(this.blinkingInterval)
                this.blinkingTimeout = null
            }

            this.blinkingTimeout = window.setTimeout(() =>
            {
                this.isBlinking = false
                this.blinkingTimeout = null
            }, 2000)

            this.blinkingInterval = window.setInterval(() =>
            {
                this.blinking = !this.blinking

                if(!this.isBlinking && !this.blinking)
                {
                    window.clearInterval(this.blinkingInterval)
                }
            }, 75)

            // Toggle titles
            this.hideTitles()
            this.showTitles()

            // Update index next frame
            this.$nextTick(() =>
            {
                this.dataIndex = _value
            })
        }
    },

    created()
    {
        this.active = this.$route.name === 'slider'
        this.index = typeof this.$route.meta.sliderIndex !== 'undefined' ? this.$route.meta.sliderIndex : 0
        this.lockLimit = this.wording.slider.carousel.lockLimit
        this.maxLimit = this.wording.slider.carousel.maxLimit
        this.visibileTimeouts = []

        this.$eventHub.$on('experience.quitFocusEnd', () =>
        {
            this.showTitles(0)

            this.visible = true
        })

        if(this.$route.name === 'home' || this.$route.name === 'slider')
        {
            this.$eventHub.$on('experience.introStart', () =>
            {
                window.addEventListener('keydown', this.onKeyDown)
            })
        }
        else
        {
            window.addEventListener('keydown', this.onKeyDown)
        }

        this.$eventHub.$on('experience.introEnd', () =>
        {
            this.hideTitles()
            this.showTitles(500)

            this.visible = true

            // If not the first slide, go to the current slide
            if(this.index !== 0)
            {
                this.$eventHub.$emit('experience.changeIndex', this.index, 0)
            }
        })

        this.$eventHub.$on('circularMenu.open', () =>
        {
            this.hideTitles()

            this.visible = false
        })

        this.$eventHub.$on('circularMenu.close', () =>
        {
            this.showTitles(0)

            this.visible = true
        })
    },

    mounted()
    {
        // this.setSwipe()
    },

    destroyed()
    {
        window.removeEventListener('keydown', this.onKeyDown)

        if(this.swipe)
        {
            document.body.removeEventListener('touchstart', this.swipe.touchStartCallback)
            document.body.removeEventListener('touchend', this.swipe.touchEndCallback)
        }
    },

    methods:
    {
        onPreviousButtonMouseEnter(_event)
        {
            if(!this.$root.config.platform.mobile)
            {
                this.leftWhiteCircleStart = - 0.5
                this.leftWhiteCircleLength = 1
            }

            this.$eventHub.$emit('grid.focusItem', _event.target)
        },

        onPreviousButtonMouseLeave()
        {
            if(!this.$root.config.platform.mobile)
            {
                this.leftWhiteCircleStart = 0
                this.leftWhiteCircleLength = 0
            }

            this.$eventHub.$emit('grid.unfocusItem')
        },

        onNextButtonMouseEnter(_event)
        {
            if(!this.$root.config.platform.mobile)
            {
                this.rightWhiteCircleStart = 0
                this.rightWhiteCircleLength = 1
            }

            this.$eventHub.$emit('grid.focusItem', _event.target)
        },

        onNextButtonMouseLeave()
        {
            if(!this.$root.config.platform.mobile)
            {
                this.rightWhiteCircleStart = 0.5
                this.rightWhiteCircleLength = 0
            }

            this.$eventHub.$emit('grid.unfocusItem')
        },

        onKeyDown(_event)
        {
            if(this.active)
            {
                if(_event.keyCode === 39)
                {
                    this.next()
                }
                else if(_event.keyCode === 37)
                {
                    this.previous()
                }
            }
        },

        setSwipe()
        {
            this.swipe = {}
            this.swipe.minDistance = 20
            this.swipe.startX = 0
            this.swipe.startY = 0

            this.swipe.touchStartCallback = (_event) =>
            {
                if(this.active)
                {
                    this.swipe.startX = _event.changedTouches[0].screenX
                    this.swipe.startY = _event.changedTouches[0].screenY

                    // Listen to touchend event
                    document.body.addEventListener('touchend', this.swipe.touchEndCallback)
                }
            }

            this.swipe.touchEndCallback = (_event) =>
            {
                if(this.active)
                {
                    const x = _event.changedTouches[0].screenX
                    const y = _event.changedTouches[0].screenY

                    const xDistance = this.swipe.startX - x
                    const yDistance = this.swipe.startY - y

                    // Horizontal swipe
                    if(Math.abs(xDistance) > Math.abs(yDistance))
                    {
                        // To left / Go right
                        if(xDistance > this.swipe.minDistance)
                        {
                            this.next()
                        }

                        // To right / Go left
                        else if(xDistance < - this.swipe.minDistance)
                        {
                            this.previous()
                        }
                    }
                }

                document.body.removeEventListener('touchend', this.swipe.touchEndCallback)
            }

            // Listen to touchstart event
            document.body.addEventListener('touchstart', this.swipe.touchStartCallback)
        },

        hideTitles()
        {
            this.isTitleVisible = false
            this.isButtonVisible = false
            this.isButtonActive = false
            this.isDescriptionVisible = false
        },

        showTitles(_duration = 1900)
        {
            if(this.visibileTimeouts.length)
            {
                for(const _timeout of this.visibileTimeouts)
                {
                    window.clearTimeout(_timeout)
                }
            }
            this.visibileTimeouts = []

            this.visibileTimeouts.push(window.setTimeout(() =>
            {
                this.isTitleVisible = true
            }, _duration + 1000))

            this.visibileTimeouts.push(window.setTimeout(() =>
            {
                this.isDescriptionVisible = true
            }, _duration + 1300))

            this.visibileTimeouts.push(window.setTimeout(() =>
            {
                this.isButtonVisible = true
            }, _duration))

            this.visibileTimeouts.push(window.setTimeout(() =>
            {
                this.isButtonActive = true
            }, _duration + 1500))
        },

        next()
        {
            if(this.index < this.lockLimit && this.index < this.maxLimit)
            {
                if(this.scroll.current > 0)
                {
                    this.animateTo(0, 0.5)
                }

                this.index++
            }
        },

        previous()
        {
            if(this.index > 0)
            {
                if(this.scroll.current > 0)
                {
                    this.animateTo(0, 0.5)
                }

                this.index--
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-slider/script.js